import { BackgroundJob, BackgroundJobStatusEnum } from 'graphql-common';

// Which status a row is badged with depends on whether it stands in for work
// the user cannot otherwise see (BE guide §2).
//
// `treeStatus` is anchored on `rootId`, so every node of a tree returns the
// identical value — it is only ever right on a row that hides the rest of the
// tree behind it. That is a root whose children aren't rendered (collapsed, or
// none spawned yet): the rollup is the only way a failed child, e.g. AI field
// detection, surfaces at all.
//
// Every other row badges with its own `displayStatus`: child rows always, and a
// root once its children are on screen. Otherwise a completed import reads
// "Failed" while the child row right below it already reports the real failure.
export default function getJobBadgeStatus(
  job: Pick<BackgroundJob, 'displayStatus' | 'treeStatus'>,
  { isChild, childrenVisible }: { isChild: boolean; childrenVisible: boolean },
): BackgroundJobStatusEnum {
  return isChild || childrenVisible ? job.displayStatus : job.treeStatus;
}
